/* DeleteAction.js */

"use strict";

const deleteSiteUtility = require("../../../../lmrbcomponents/siteexplorer/deleteSiteUtility.js");

class DeleteAction {
    constructor(logger, gameEditor, modalUserFeedback, SiteEntity) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._SiteEntity = SiteEntity;
    }

    run() {
        const site = this._gameEditor.getSite();
        if (site._id === site._tenantId) {
            return this._modalUserFeedback.displayError({
                error: {
                    title: "Delete site",
                    errorTitle: "Delete site",
                    errorMsg: "Sorry, you can’t delete the root site.",
                    errorCode: "",
                },
            });
        }

        const tenantId = site.tenantId;
        let expandedIds = [];

        return deleteSiteUtility
            .expandSiteIds(this._SiteEntity, tenantId, [site.id])
            .then((ids) => {
                expandedIds = ids;
                return deleteSiteUtility.checkDeleteBlockers(this._SiteEntity, tenantId, ids);
            })
            .then((blockers) => {
                if (blockers.hasDeviceSite) {
                    return Promise.reject({
                        msg: deleteSiteUtility.buildDeviceSiteMessage(blockers.hasDeviceSiteCount),
                    });
                }

                let message = deleteSiteUtility.buildSingleSiteDeleteMessage({
                    siteName: site.name,
                    expandedIds,
                    hasChildSite: blockers.hasChildSite,
                });

                return this._gameEditor
                    .runQuickConfirmationActionWorkflow(
                        {
                            message: message,
                            title: "Delete",
                            confirmDetails: {
                                text: "Confirm",
                                type: "destructive",
                            },
                            rejectDetails: {
                                text: "Cancel",
                                type: "text",
                            },
                        },
                        () => this.doTheThang(tenantId, expandedIds)
                    )
                    .finally(() => {
                        if (this._gameEditor.currentEntityRemoved) {
                            this._gameEditor.currentEntityRemoved = false;
                            this._gameEditor.currentEntityDeleteInProgress = false;
                            this._gameEditor.closeEditor(this._gameEditor.editorTabStateId, true);
                        }
                    });
            })
            .catch((err) => {
                this._logger.warn({error: err}, "DeleteAction.run() - Error");
                return this._modalUserFeedback.displayError({
                    error: {
                        title: "Delete site",
                        errorTitle: "Delete site",
                        errorMsg: err.msg || err.message || err,
                        errorCode: "",
                    },
                });
            });
    }

    doTheThang(tenantId, expandedIds) {
        return this._SiteEntity
            .runSiteDeleteWork(
                tenantId,
                deleteSiteUtility.buildWorkTarget(expandedIds),
                {},
                {launchAndForget: false},
                deleteSiteUtility.makeProgressCallback(this._modalUserFeedback)
            )
            .then((workResults) => {
                this._SiteEntity.throwWorkErrors(workResults);
                return Promise.resolve();
            })
            .catch((err) => {
                this._gameEditor.currentEntityDeleteInProgress = false;
                if (err.message && err.message.search("EntityInteractionsError") !== -1) {
                    return this._modalUserFeedback.displayError({
                        error: {
                            title: "Delete site",
                            errorTitle: "Delete site",
                            errorMsg:
                                "Sorry, you can’t delete a site that has devices assigned to it. Remove the devices from the site and its child sites.",
                        },
                    });
                }
                this._logger.warn({error: err}, "DeleteAction.run() - Error");
                return Promise.reject(err);
            });
    }
}

module.exports = DeleteAction;

DeleteAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Site",
];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    title: "Delete site",
    shown: true,
    order: 1,
};
